
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        if (!data || Object.keys(data).length === 0) {
            return axios.get(`${API_URL}/cash-closures`, { headers: authHeader() });
        }
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/cash-closures?${queryString}`;
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/cash-closures/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/cash-closures`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/cash-closures/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/cash-closures/${id}`, { headers: authHeader() });
    },
    
};